// extracted by mini-css-extract-plugin
export var fs = "heroImage-module--fs--65jT6";
export var image = "heroImage-module--image--GVbQC";
export var imageDesktop = "heroImage-module--imageDesktop--4tAB+";
export var imageMobile = "heroImage-module--imageMobile--SVMBY";
export var lg = "heroImage-module--lg--ZYmsO";
export var md = "heroImage-module--md--VXt4i";